import { BaseApi } from "@/api/BaseApi";
import Config from "@/const/Config";
import { GetListRes, GetDaichouInfoRes, GetShinseiReq, GetYuukyuuListRes, ListSearchItem, YuukyuuFuyoReq, YuukyuuDeleteReq, YuukyuuKanriOption, DaichouInfoForNewForm, GetCreateNewDaichouRes } from '@/types/YuukyuuKanri'

export class YuukyuuKanriApi extends BaseApi {
  /**
   * 有給休暇申請情報を取得します
   * @returns
   */
  public async getShinseiList(req: GetShinseiReq): Promise<GetYuukyuuListRes> {
    try {
      const res = await this.post<GetYuukyuuListRes>(Config.API_URL + "/yuukyuukanri/shinsei_list", req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 特定ユーザの有給休暇管理台帳情報を取得します
   * @returns
   */
  public async getInfo(id: number): Promise<GetDaichouInfoRes> {
    try {
      const req = {
        user_id: id
      }
      const res = await this.post<GetDaichouInfoRes>(Config.API_URL + "/yuukyuukanri/info", req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 有給休暇管理台帳情報一覧を取得します
   * @returns
   */
  public async getList(params: ListSearchItem): Promise<GetListRes> {
    try {
      const res = await this.post<GetListRes>(Config.API_URL + "/yuukyuukanri/list", params);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 今年度付与日数の更新
   * @returns
   */
  public async fuyoUpdate(req: YuukyuuFuyoReq): Promise<GetYuukyuuListRes> {
    try {
      const res = await this.post<GetYuukyuuListRes>(Config.API_URL + "/yuukyuukanri/update", req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 有給取消
   * @returns
   */
  public async yuukyuuDelete(req: YuukyuuDeleteReq): Promise<boolean> {
    try {
      const res = await this.delete<boolean>(Config.API_URL + "/yuukyuukanri/delete", req);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  // 個人別有給管理台帳の付与日選択オプション取得
  public async getFuyobiOptions(userId: number): Promise<YuukyuuKanriOption[]> {
    try {
      const res = await this.post<YuukyuuKanriOption[]>(Config.API_URL + "/yuukyuukanri/fuyobi/options", { 'userId': userId });
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  // 指定した付与日の台帳情報を取得
  public async getPastDaichouInfo(userId: number, start: string, end: string): Promise<GetDaichouInfoRes> {
    try {
      const res = await this.post<GetDaichouInfoRes>(Config.API_URL + "/yuukyuukanri/fuyobi/pastInfo", { 'userId': userId, 'start': start, 'end': end });
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  // 新規に有休付与データを登録します
  public async createNewFuyoData(form: DaichouInfoForNewForm): Promise<GetCreateNewDaichouRes> {
    try {
      const res = await this.post<GetCreateNewDaichouRes>(Config.API_URL + "/yuukyuukanri/fuyo/create", form);
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }
}
